import React from 'react';
import type { IconProps } from '../types';

export const OrientationSwitchR = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.57766 17.4182L9.4655 19.8288L6.80457 21.4557"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.5918 15C19.8503 15.1669 20.067 15.3909 20.2253 15.6547C20.3836 15.9186 20.4793 16.2152 20.5049 16.5218C20.5049 18.3123 16.991 19.7938 12.5153 19.946"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.46782 19.828C5.73931 19.4354 3 18.1038 3 16.5218C3.02464 16.2179 3.11841 15.9236 3.27416 15.6614C3.4299 15.3992 3.6435 15.1761 3.89865 15.0091"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.02502 15.127C8.51721 15.127 8.20618 14.8096 8.20618 14.2764V6.69092C8.20618 6.15771 8.51721 5.84033 9.02502 5.84033H11.8434C13.8239 5.84033 15.0109 6.93848 15.0109 8.69043C15.0109 9.88379 14.4015 10.8613 13.3414 11.2739L14.7887 13.813C14.9283 14.0479 14.9664 14.1875 14.9664 14.3779C14.9664 14.8096 14.611 15.127 14.1412 15.127C13.754 15.127 13.5636 14.9873 13.3097 14.5366L11.6783 11.5532H9.84387V14.2764C9.84387 14.8096 9.53284 15.127 9.02502 15.127ZM9.84387 10.2964H11.691C12.7321 10.2964 13.3351 9.71875 13.3351 8.72852C13.3351 7.76367 12.694 7.16699 11.6593 7.16699H9.84387V10.2964Z"
      fill="currentColor"
    />
  </svg>
);

export default OrientationSwitchR;
